import { motion, AnimatePresence } from 'framer-motion';
import useThemeStore from '../../store/themeStore';
import { themes } from '../../constants/themes';

const ThemeSelector: React.FC = () => {
    const { isSelectorOpen, closeSelector, setTheme, themeId } = useThemeStore();

    const handleSelectTheme = (id: string) => {
        setTheme(id);
        closeSelector();
    };

    return (
        <AnimatePresence>
            {isSelectorOpen && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={closeSelector}
                        className="fixed inset-0 bg-black/60 z-50"
                    />

                    {/* Modal */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ type: 'spring', damping: 25 }}
                        className="fixed inset-x-4 top-1/2 -translate-y-1/2 max-w-md mx-auto bg-slate-800 rounded-2xl z-50 overflow-hidden"
                    >
                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
                            <h3 className="text-white font-medium text-lg">Chọn giao diện</h3>
                            <button
                                onClick={closeSelector}
                                className="p-2 hover:bg-white/10 rounded-full"
                            >
                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Theme Grid */}
                        <div className="p-4 grid grid-cols-1 gap-3">
                            {themes.map((theme) => (
                                <button
                                    key={theme.id}
                                    onClick={() => handleSelectTheme(theme.id)}
                                    className={`relative flex items-center p-4 rounded-xl transition-all ${themeId === theme.id
                                            ? 'ring-2 ring-white bg-white/10'
                                            : 'hover:bg-white/5'
                                        }`}
                                >
                                    {/* Theme Preview Gradient */}
                                    <div
                                        className={`w-16 h-16 rounded-xl bg-gradient-to-br ${theme.artworkGradient} flex-shrink-0`}
                                    />

                                    {/* Theme Info */}
                                    <div className="ml-4 text-left">
                                        <div className="text-white font-medium">{theme.nameVi}</div>
                                        <div className="text-white/60 text-sm">{theme.name}</div>
                                    </div>

                                    {/* Selected Indicator */}
                                    {themeId === theme.id && (
                                        <div className="absolute right-4">
                                            <svg className="w-6 h-6 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    )}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default ThemeSelector;
